module.exports = "<div class=\"cal-heatmap\" config=\"config\"></div>\n";


//////////////////
// WEBPACK FOOTER
// ./client/common/directives/heatmap/heatmap.html
// module id = 513
// module chunks = 0